import { EnumeratorStackItem } from './EnumeratorStackItem';
export class IteratorStackItem extends EnumeratorStackItem {
    asIterator() {
        return this.value;
    }
}

//# sourceMappingURL=IteratorStackItem.js.map
